<script>
	// Stores
	import MeetingStore from '@/Stores/Racing/MeetingStore.js';
	// Components
	import Switch from '@/Components/Switch.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let meeting;

	let bonusDisabledChecked = meeting && !meeting.bonus_disabled;

	function updateBonusDisabled() {
		MeetingStore.updateMeetingBonusDisabled(meeting.id, !bonusDisabledChecked)
			.then(() => {
				notify({
					type: 'success',
					title: `${meeting.name}`,
					message: `Bonus Bets for Meeting updated to ${bonusDisabledChecked ? 'On' : 'Off'}`,
					timeout: 3
				});
			})
			.catch(() => {
				bonusDisabledChecked = !bonusDisabledChecked;
				notify({
					type: 'danger',
					title: `${meeting.name}`,
					message: 'Failed to update Bonus Bets',
					timeout: 3
				});
			});
	}
</script>

<div class="ml-4 mr-2 font-semibold uppercase">Bonus Bets</div>
<Switch
	on:change={updateBonusDisabled}
	name={`bonus-meeting-${meeting.id}`}
	bind:checked={bonusDisabledChecked}
	small={true}
/>
